import api from '../../services/api';
import moment from 'moment';
import _ from 'lodash';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        headers: [
            { text: 'Date Uploaded', value: 'dateUploaded', sortable: true},
            { text: 'Batch ID', value: 'batchId', sortable: true},
            { text: 'User', value: 'currentUser', sortable: true},
            { text: 'SKU Count', value: 'totalCount', sortable: true},
            { text: 'Status', value: 'statusLabel', sortable: true, width: '200'},
            { text: 'Extensiv PO', value: 'extensivPoNumber', sortable: true, width: '160'},
			{ text: 'Actions', width: '150', align: 'center', alignHeader: 'center' }
        ],
        loading: false,
        loading2: false,
        allItems: [],
        items: [],
        itemsByBatchId: [],
        userRecords: [],
        statusRecords: []
    },
    getters: {
        headers: state => state.headers,
        items: state => state.items,
        loading: state => state.loading,
        loading2: state => state.loading2,
        itemsByBatchId: state => state.itemsByBatchId,
        userRecords: state => state.userRecords,
        statusRecords: state => state.statusRecords,
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setLoading2: (state, payload) => state.loading2 = payload,
        getAllitems: (state, payload) => state.allItems = payload,
        [type.Extensiv_GET_LOGS]: (state, payload) => state.items = payload,
        [type.Extensiv_GET_LOGS_BY_BATCHID]: (state, payload) => state.itemsByBatchId = payload,
        [type.GET_USER_RECORDS]: (state, payload) => state.userRecords = payload,
        [type.GET_STATUS_RECORDS]: (state, payload) => state.statusRecords = payload,
        [type.QB_GET_LOGS]: (state, payload) => state.items = payload
    },
    actions: {
        [type.Extensiv_GET_LOGS]: async ({ commit }, filters = {}) => {
            commit('setLoading', true);
            try {
                let query = 'searchFilter=Extensiv';
                // Reuse the same endpoint! Just filter by parser_type = Extensiv
                const response = await api.get(`/file/stored-list?${query}`);
                // api baseURL already prefixes /api, so leave path relative here.
                const poResponse = await api.get('/extensiv/pobatches');
                const poMap = {};
                (poResponse.data || []).forEach(p => { poMap[p.batchId] = p; });
                const statusMap = ['Processing', 'Processing', 'WORKING', 'SHIPPED', 'IN_TRANSIT', 'DELIVERED', 'CHECKED_IN', 'RECEIVING', 'CLOSED', 'CANCELLED', 'DELETED', 'ERROR'];
                const result = response.data.map(e => {
                    const po = poMap[e.batch_id] || {};
                    const fileStatusLabel = typeof e.status === 'string'
                        ? e.status
                        : statusMap[e.status] || 'Processing';
                    // Prefer PO status from Extensiv; if it's only WORKING but file status is more
                    // specific (e.g., enum 7 => RECEIVING), use the file status instead.
                    const derivedStatus = po.status === 'WORKING' && fileStatusLabel !== 'WORKING'
                        ? fileStatusLabel
                        : (po.status || fileStatusLabel);
                    return {
                        id: e.id,
                        batchId: e.batch_id,
                        currentUser: e.curr_user,
                        totalCount: e.total_count,
                        status: derivedStatus,
                        statusLabel: derivedStatus,
                        extensivPoNumber: po.extensivPoNumber || '',
                        extensivPoId: po.extensivPoId || '',
                        lastError: po.lastError || '',
                        dateUploaded: new Date(e.date_uploaded).toLocaleString('en-US', { 
                            month: '2-digit', day: '2-digit', year: 'numeric', 
                            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true 
                        }),
                        fileLink: e.file_link
                    }
                });
                commit(type.QB_GET_LOGS, result);
            } catch (err) {
                console.error(err);
                commit(type.QB_GET_LOGS, []);
            } finally {
                commit('setLoading', false);
            }
        },

        [type.Extensiv_GET_LOGS_BY_BATCHID]: async ({ commit }, batchId) => {
            commit('setLoading2', true);
            commit(type.Extensiv_GET_LOGS_BY_BATCHID, []);
            try {
                const response = await api.get(`/extensiv/pobatches/${batchId}`);
                const result = (response.data || []).map(it => ({
                    ...it,
                    statusLabel: it.status || 'WORKING'
                }));
                commit(type.Extensiv_GET_LOGS_BY_BATCHID, result);
                return result;
            } catch (error) {
                console.error(error);
                commit(type.Extensiv_GET_LOGS_BY_BATCHID, []);
                return [];
            } finally {
                commit('setLoading2', false);
            }
        },
    
        [type.GET_INVOICE_RECORDS]: async ({commit}) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            commit(type.GET_INVOICE_RECORDS, []);

            try {
                let response = await api.get(`/get/invoice-information`);
                if(response.status === 200){
                    let result = response.data.map(e => {
                        let dateProcessed = moment(e.dateProcessed).utcOffset('+08:00').format('MM/DD/YYYY');
                        let dropShipFee = e.dropShipFee === undefined ? '' : e.dropShipFee;
                        let type = e.type === 'fileFeed' ? 'Template' : e.type
                        return {
                            ...e,
                            dateProcessed,
                            dropShipFee,
                            type
                        }
                    });
                    
                    commit(type.GET_INVOICE_RECORDS, result);
                    commit(`global/${type.REMOVE_LOADING}`, 'success', { root: true })
                }
            } catch (error) {
                commit(type.GET_INVOICE_RECORDS, []);
                commit(`global/${type.REMOVE_LOADING}`, 'error', { root: true });
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }
        }
    }
}